module.exports = __webpack_public_path__ + "img/1094.401347b7.gif";